import React from 'react';
import DOMPurify from 'dompurify';
import styled from 'styled-components';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '2560px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const MarkDownContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 120px;
  padding-right: 120px;
  @media only screen and ${device.tablet} {
    padding: 0px 24px;
    font-size: 36px;
  }
  h1 {
    text-align: left;
    font-family: Inter;
    font-weight: 500;
    margin: unset;
    margin-top: 10px;
    font-size: 50px;
    line-height: 30px;
    letter-spacing: 0%;
  }
  h2 {
    font-family: Inter;
    text-align: left;
    margin: unset;
    margin-top: 10px;
    font-size: 32px;
    line-height: 30px;
    letter-spacing: 0%;
  }
  h3 {
    font-family: Inter;
    text-align: left;
    margin: unset;
    margin-top: 10px;
    font-size: 28px;
    line-height: 30px;
    letter-spacing: 0%;
  }
  h4 {
    font-family: Inter;
    text-align: left;
    margin: unset;
    margin-top: 10px;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0%;
  }
  p,
  div,
  span {
    text-align: left;
    margin: unset;
    margin-top: 10px;
    font-family: Inter;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 0%;
  }
  ul,
  ol {
    margin: unset;
    margin-top: 10px;
  }
  img {
    height: 513px;
    width: 931px;
    border-radius: 14px;
    align-self: center;
    @media only screen and ${device.tablet} {
      width: 375px;
      height: auto;
    }
  }
`;
const BlogPost = ({ data }) => {
  function cleanHTMLStyle(html) {
    html = html.replace(/<br\s*\/?>/gi, "");
    html = html.replace(/&nbsp;\s*?/gi, "");

    html = html.replace(/style="([^"]*)"/g, (match, styles) => {
      const allowedStyles = [
        'color',
        'font-size',
        'font-weight',
        'font-style',
        'text-decoration',
        'letter-spacing',
        // 'line-height',
      ];

      let filteredStyles = styles
        .split(';')
        .map((style) => style.trim())
        .filter((style) => {
          let styleName = style.split(':')[0]?.trim();
          return allowedStyles.includes(styleName);
        })
        .join('; ');

      return filteredStyles ? `style="${filteredStyles}"` : '';
    });
    return html;
  }

  let cleanedHTML = cleanHTMLStyle(data?.content);

  const cleanHTML = DOMPurify.sanitize(cleanedHTML);
  return <MarkDownContainer dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
};

export default BlogPost;
